module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      expanded: _vm.expandedActive
    },
    attrs: {
      "id": "meiaNews"
    }
  }, [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newsInner"
  }, [_c('p', [_vm._v("NEWS")]), _vm._v(" "), _c('p', [_vm._v("PRETTY FOOTER Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean nisi tellus, fermentum finibus lectus quis, interdum molestie leo. Morbi ultrices scelerisque lacus.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6204eab9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/meiaNews.vue
// module id = 59
// module chunks = 1